import { Component, OnInit } from '@angular/core';
import { BirthdayListService } from '../../services/birthday-list.service';
import { PlayroomService } from '../../services/playroom.service';
import { CommonMethodesService } from '../../services/common-methodes.service';
import { Playroom } from '../../models/playroom.model';
import { CostumArray } from '../../models/customArray';
import { RoomArray } from '../../models/roomArray';
import { ZoneArray } from '../../models/zoneArray';
import { BirthDay } from '../../models/birthday.model';
import { Zone } from '../../models/zone.model';
import { User } from 'src/app/models/user.model';
import { RodjendanskezoneService } from '../../services/rodjendanskezone.service';
import { BirthDayList } from '../../models/birthdaylistmodel';
import { ModalController } from '@ionic/angular';
import { EditBirthdayComponent } from '../../components/modals/edit-birthday/edit-birthday.component';
import { BirthdayDeleteModalComponent } from '../../components/modals/birthday-delete-modal/birthday-delete-modal.component';
import { map } from 'rxjs/operators';
import { DismissBirthdayModalComponent } from '../../components/modals/dismiss-birthday-modal/dismiss-birthday-modal.component';
import { Router } from '@angular/router';
import { CurrentValueService } from '../../services/current-value.service';
import { BirthdayVisitorStat } from '../../models/birtthdayVisitorStat';


@Component({
  selector: 'app-birthday-list',
  templateUrl: './birthday-list.page.html',
  styleUrls: ['./birthday-list.page.scss'],
})
export class BirthdayListPage implements OnInit {

  birthdays$ = this.birthdayListService.birthdays$;
 
  paginationSettings = {
  totalItems: 0,
  itemsPerPage: 10,
  currentPage: 1
};


  itemsPerPageLarge: number = 2147483647;
  playroom: Playroom[]
  userList: Array<CostumArray>;
  selectedUser: CostumArray | null = null
  roomList: Array<RoomArray>;
  selectedRoom: RoomArray | null = null
  zoneList: Array<ZoneArray>
  selectedZone: ZoneArray | null = null
  birthdayAdd: BirthDay
  birthdayListList = BirthDay
  zone: Zone[]
  users: User[];
  cityQuery: string = ''
  roomNameQuery: string = '';
  birthdayZoneNameQuery: string = '';
  VisitorNameQuery: string = '';
  // FinalPlannedPriceFromQuery: string = '';
  // FinalPlannedPriceToQuery: string = '';
  CallDateFromQuery: string = '';
  CallDateToQuery: string = '';
  AppointmentDateFromQuery: string = '';
  AppointmentDateToQuery: string = '';
   PricePerChildrenFromQuery:string=''
      PricePerChildrenToQuery:string=''
  // PlannedPriceFromQuery: string = '';
  // PlannedPriceToQuery: string = '';
  PlannedChildNumberFromQuery: string = '';
  PlannedChildNumberToQuery: string = '';
  PresentChildNumberQuery: string = '';
  PresentChildNumberFromQuery: string = '';
  PresentChildNumberToQuery: string = '';
  TotalPricePaidQuery: string = '';
  TotalPricePaidFromQuery: string = '';
  TotalPricePaidToQuery: string = '';
  StatusCallQuery: string = '';
  NumberOfBirthdayFromQuery:string=''
  NumberOfBirthdayToQuery:string='';
  AdvancePaymentWillQuery:string='';
  AdvancePricePaidFromQuery:string='';
  AdvancePricePaidToQuery:string='';
  pageSize: number = 2147483647;

  constructor(private birthdayListService: BirthdayListService, private roomService: PlayroomService, private commonMethodsService: CommonMethodesService,
    private rodjendanskezoneservice: RodjendanskezoneService, private modalController: ModalController, private router: Router,
    private currentValue: CurrentValueService) { }

  ngOnInit() {
    console.log('BITHAY', this.birthdays$)
    this.loadBirthday()
this.birthdayListService.birthdayPagination$.subscribe(p => {
      if (p) this.paginationSettings = p;
    });

this.birthdayListService.birthdayPagination$.subscribe(pagination => {
  this.paginationSettings = pagination;
   
     });
    this.roomService.getAllPlayroomsSub().subscribe(data => {
      this.playroom = data;
      this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);
    });

 
 
  }

 
statusCallHelper(value: number) {
    if (value === 0) {
      return "ZAKAZAN"
    }
    else if (value === 1) {
      return "OTKAZAN"
    }
    else if (value === 2) {
      return "RAPITUJE SE"

    }
     
    else if (value === 3) {
      return "RAZMISLIĆE"

    }
    else  if (value === 4) {
      return "POZVATI GA"

    }
    else  if (value === 5) {
      return "REZERVISAN"

    }
  }



 advancePaymetWillHelper(value: number) {
    if (value ===0) {
      return "NIJE PLAĆEN"
    }
    else if (value === 1) {
      return "PRN"
    }
    else if (value === 2) {
      return "KEŠ"
    }
 else if (value === 3) {
      return "KARTICA"
    }
 else if (value === 4) {
      return "PRN SVE"
    }
 else if (value === 5) {
      return "KEŠ SVE"
    }

    else if (value === 6) {
      return "KARTICA SVE"
    }
  }
  
  onUserChange(event: any) {
    this.getReducedArray()
    this.zoneList = []
    this.cityQuery = this.selectedUser.display
    console.log(" this.cityQuery on UserChange", this.cityQuery)
 
 
  }

  getReducedArray() {
    this.roomList = []

    var disp = this.selectedUser?.display
    console.log("Lista rodjendana Room - DISP", disp)

    this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, disp);
    console.log("Lista rodjendana Room - RoomList", this.roomList)

    this.zoneList = []

  }

  onRoomChange(event: any) {
    this.selectedZone = null;
    this.zoneList = []
    this.getReducedZoneArray()

    console.log("SELEKTOVANI Igraonica", this.selectedRoom)
    this.commonMethodsService.getEmployeesByRoom(
      parseInt(this.selectedRoom.value),
      this.paginationSettings.currentPage,
      this.paginationSettings.itemsPerPage
    ).subscribe(employees => {
      console.log("EMP", employees);
      if (employees.length > 0) {
        this.birthdayAdd.EmployeeId = employees[0].id;
        this.birthdayAdd.EmployName = employees[0].username;
      }

    });
    this.cityQuery = '';
    this.roomNameQuery = this.selectedRoom.display;
  }
  getReducedZoneArray() {

    this.rodjendanskezoneservice.getAllPlayroomZonesSub({ currentPage: this.paginationSettings.currentPage, itemsPerPage: this.itemsPerPageLarge }).subscribe(data => {
      this.zone = data;
      var disp = this.selectedRoom.display;
      this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, disp);

      if (this.zoneList.length > 0) {

        const prev = this.selectedZone ? this.zoneList.find(z => z.value === this.selectedZone.value) : null;

      }

    })

  }
  onZoneChange(event: any) {
    console.log('Zona selektovana:', this.selectedZone);
    this.cityQuery = '';
    this.roomNameQuery = '';
    this.birthdayZoneNameQuery = this.selectedZone.display
  }

  async loadSearchResult() {
    this.birthdayListService.getAllBirthday(
      {
        currentPage: this.paginationSettings.currentPage,
        itemsPerPage: this.paginationSettings.itemsPerPage,
        cityQuery: this.cityQuery,
        roomNameQuery: this.roomNameQuery,
        birthdayZoneNameQuery: this.birthdayZoneNameQuery,
        VisitorNameQuery: this.VisitorNameQuery,       
        CallDateFromQuery: this.CallDateFromQuery,
        CallDateToQuery: this.CallDateToQuery,
        AppointmentDateFromQuery: this.AppointmentDateFromQuery,
        AppointmentDateToQuery: this.AppointmentDateToQuery,      
        PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
        PricePerChildrenToQuery: this.PricePerChildrenToQuery, 
        PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
        PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
        PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
        PresentChildNumberToQuery: this.PresentChildNumberToQuery,
        TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
        TotalPricePaidToQuery: this.TotalPricePaidToQuery,
        StatusCallQuery: this.StatusCallQuery,
        NumberOfBirthdayFromQuery:this.NumberOfBirthdayFromQuery,
        NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
        AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
        AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
        AdvancePricePaidToQuery:this.AdvancePricePaidToQuery
      })  


      console.log ( "Ispred LoadBirthdayVisitorReportLoadBirthdayVisitorReport Visitor query",this.VisitorNameQuery)


  
    }

  resetFilters() {
    this.cityQuery = ''
    this.roomNameQuery = '';
    this.birthdayZoneNameQuery = '';
    this.VisitorNameQuery = '';  
     this.PricePerChildrenFromQuery=''   
     this.PricePerChildrenToQuery=''    
    this.CallDateFromQuery = '';
    this.CallDateToQuery = '';
    this.AppointmentDateFromQuery = '';
    this.AppointmentDateToQuery = '';  
    this.PlannedChildNumberFromQuery = '';
    this.PlannedChildNumberToQuery = '';
    this.PresentChildNumberQuery = '';
    this.PresentChildNumberFromQuery = '';
    this.PresentChildNumberToQuery = '';
    this.TotalPricePaidFromQuery = '';
    this.TotalPricePaidToQuery = '';
    this.StatusCallQuery = '0';
    this.selectedUser=null;
    this.selectedRoom=null;
    this.selectedZone=null;
   this. NumberOfBirthdayFromQuery='';
   this.NumberOfBirthdayToQuery='';
   this.AdvancePaymentWillQuery="" ,
   this.AdvancePricePaidFromQuery='',
   this.AdvancePricePaidToQuery=''   

  }
    
  async openEditBirthdayModal(birthdayListList) {
    console.log("Editmethod - birthdayListList", birthdayListList)

    const modal = await this.modalController.create({
      component: EditBirthdayComponent,
      componentProps: { birthdayListList: { ...birthdayListList } },
      cssClass: 'medium-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  async openDeleteBirthDayModal(birthdayListList) {
    const modal = await this.modalController.create({
      component: BirthdayDeleteModalComponent,
      componentProps: { birthdayListList: { ...birthdayListList } },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();

  }
async openEditDismissBirthdayModal(birthdayListList) {
const modal = await this.modalController.create({
      component: DismissBirthdayModalComponent,
     componentProps: { birthdayListList: { ...birthdayListList } },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
await modal.present();
}
 


getLocalTimeFromServer(utcString: string): string {
  if (!utcString) return '';
  const date = new Date(utcString);
  return date.toLocaleString('sr-RS');
}
 ExportCSV() {
    this.birthdayListService.exportCSV({
      currentPage: this.paginationSettings.currentPage, itemsPerPage: this.paginationSettings.itemsPerPage, pageSize: this.pageSize,
      cityQuery: this.cityQuery,
      roomNameQuery: this.roomNameQuery,
      birthdayZoneNameQuery: this.birthdayZoneNameQuery,
      VisitorNameQuery: this.VisitorNameQuery,   
      CallDateFromQuery: this.CallDateFromQuery,
      CallDateToQuery: this.CallDateToQuery,
      AppointmentDateFromQuery: this.AppointmentDateFromQuery,
      AppointmentDateToQuery: this.AppointmentDateToQuery,    
       PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,  
      PricePerChildrenToQuery: this.PricePerChildrenToQuery,     
      PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
      PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
      PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
      PresentChildNumberToQuery: this.PresentChildNumberToQuery,
      TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
      TotalPricePaidToQuery: this.TotalPricePaidToQuery,
      StatusCallQuery: this.StatusCallQuery

    }).subscribe
      (
        response => {
          this.blobToFile(response, "text/csv", "Export zakazanih rodjendana.csv");
        }
      )
  }

 blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }
  
  openBirthdayDetails(b: any) {
    this.currentValue.set('birthday', b);
    this.router.navigate(['/admin/birthday-details', b.visitorId, 'birthdays', b.id]);
  }


  loadBirthday(){
 this.StatusCallQuery = '0'
    this.birthdayListService.getAllBirthday({
      currentPage: this.paginationSettings.currentPage, itemsPerPage: this.paginationSettings.itemsPerPage,
      cityQuery: this.cityQuery,
      roomNameQuery: this.roomNameQuery,
      birthdayZoneNameQuery: this.birthdayZoneNameQuery,
      VisitorNameQuery: this.VisitorNameQuery,      
      CallDateFromQuery: this.CallDateFromQuery,
      CallDateToQuery: this.CallDateToQuery,
      AppointmentDateFromQuery: this.AppointmentDateFromQuery,
      AppointmentDateToQuery: this.AppointmentDateToQuery,
      PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
      PricePerChildrenToQuery: this.PricePerChildrenToQuery,  
      PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
      PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
      PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
      PresentChildNumberToQuery: this.PresentChildNumberToQuery,
      TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
      TotalPricePaidToQuery: this.TotalPricePaidToQuery,
      StatusCallQuery: this.StatusCallQuery,
      NumberOfBirthdayFromQuery: this.NumberOfBirthdayFromQuery,
      NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
      AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
      AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
      AdvancePricePaidToQuery:this.AdvancePricePaidToQuery

    })


  }
 changePage(page: number) {
    this.paginationSettings.currentPage = page;
    this.loadBirthday();
  }

  onStatusCallChange(event:any){
    
  } 

}
